<template>
  <div>
    <div class="boder-layout" :class="showUpdateTag?'showboder':''" @mouseenter="$store.state.editStatus === 0?showUpdateTag=true:''" @mouseleave="showUpdateTag=false">
      <div class="centerslot">
        <slot></slot>
        <div class="btnlist">
          <div class="nomal" @click="dialogVisible=true" :class="showUpdateTag?'updateBtn':''">
            {{btnText}}
          </div>
          <!-- <div v-if="indexs!=-1" class="nomal " @click="dialogDelete=true" :class="showUpdateTag?'deleteBtn':''">
            删除
          </div> -->
        </div>
      </div>
    </div>
    <el-dialog class="editUp" :append-to-body="true" center :visible.sync="dialogDelete" width="40%">
      <div slot="title" class="title">
        <span>删除提示</span>
      </div>
      <div>请确定删除这个数据吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogDelete = false">取消</el-button>
        <el-button size="small" type="primary" @click="deleteData">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog class="editUp" :append-to-body="true" center :visible.sync="dialogVisible" width="40%">
      <div slot="title" class="title">
        <span>{{btnText}}{{btnText.indexOf('编辑数量')!=-1?'（建议4-6个）':''}}</span>
      </div>
      <component :is="componentsName" :pageObj="pageObj"  :closedialog="closedialog" :indexs="indexs" :caseIndex="caseIndex" v-if="dialogVisible" />
    </el-dialog>
  </div>
</template>

<script>
import TitleEdit from './title_edit.vue'
import TitleEditTd from './title_edittd.vue'
import TitleEditValue from './title_editValue.vue'
import TitleEditApp from './title_editApp.vue'

import ContentEdit from './content_edit.vue'
import ImageEdit from './image_edit.vue'
import PainSpotEdit from './painSpot_edit.vue'
import PainSpotAdd from './painSpot_add.vue'
import CoreValuesEdit from './coreValues_edit.vue'
import CoreValuesAdd from './coreValues_add.vue'
import featureApplicationAdd from './featureApplication_add.vue'
import featureApplicationEdit from './featureApplication_edit.vue'
import IndexEdit from './index_edit.vue'
import BannerEdit from './banner_edit.vue'
// 典型案例
import IndexEditCase from './case/index_edit_Case.vue'
import AddressEditCase from './case/address_edit_Case.vue'
import ContentEditCase from './case/content_edit_Case.vue'
import ImageEditCase from './case/image_edit_Case.vue'
import LightPointListCase from './case/light_point_list_Case.vue'
import LightPointCase from './case/light_point_Case.vue'
import TitleEditCase from './case/title_edit_Case.vue'
import LabelEditCase from './case/label_edit_Case.vue'

import { addProgrammeCustomDetail } from "@/api/pageTemplate.js";

export default {
  name: 'borderUpdateCom',
  props: {
    // 上一页传过来的数据
    pageObj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 按钮文字
    btnText: {
      type: String,
      default: ''
    },
    // 当前模块index
    indexs: {
      type: Number,
      default: -1
    },
    // 组件名称
    componentsName: {
      type: String,
      default: ''
    },
    // 模块中的第几个数据
    nowNumber: {
      type: Number,
      default: 0
    },
    // 典型案例第几个模块
    caseIndex: {
      type: Number,
      default: 0
    },
  },
  components: {
    TitleEdit,
    ContentEdit,
    ImageEdit,
    PainSpotEdit,
    PainSpotAdd,
    CoreValuesEdit,
    CoreValuesAdd,
    featureApplicationAdd,
    featureApplicationEdit,
    IndexEdit,
    TitleEditApp,
    TitleEditValue,
    TitleEditTd,
    BannerEdit,
    // 典型案例
    IndexEditCase,
    AddressEditCase,
    ContentEditCase,
    ImageEditCase,
    LightPointListCase,
    TitleEditCase,
    LightPointCase,
    LabelEditCase
  },
  data () {
    return {
      showUpdateTag: false,
      dialogVisible: false,
      dialogDelete: false,
      saveData: {},
      editData: {},
      moduleData: {},
    }
  },
  created () {
    this.$nextTick(() => {
      this.editData = JSON.parse(this.$store.state.pageTemplateData.customDetailList[this.nowNumber].content)
      // this.moduleData = JSON.parse(this.$store.state.pageTemplateData.customDetailList[this.nowNumber].content).moduleList[this.indexs]
      this.saveData = this.$store.state.pageTemplateData.customDetailList[this.nowNumber]
    })
  },
  methods: {
    //关闭弹框
    closedialog () {
      this.dialogVisible = false
    },
    //删除数据
    deleteData () {
      this.editData.moduleList.splice(this.indexs, 1)
      // console.log(this.moduleData)
      this.updateData()
    },

    updateData () {

      // this.editData.moduleList[this.indexs] = this.moduleData
      this.saveData.content = JSON.stringify(this.editData)
      addProgrammeCustomDetail(this.saveData).then(res => {
        if (res.data == 1) {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.closedialog()
          this.$store.commit('changeRefresh')
        } else {
          this.$message({
            message: res.msg,
            type: 'success'
          });
        }

      })
    },

  }
}

</script>
<style  lang="scss" scoped>
::v-deep .editUp {
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #333;

    span {
      &:nth-child(2) {
        font-size: 12px;
        color: #999;
      }
    }
  }

  .label {
    display: flex;
    align-items: center;
  }

  .table {
    .img {
      width: 100px;
      height: 50px;
    }
  }

  .dialog-foote {
    text-align: center;
    display: flex;
    justify-content: center;
  }
}

.boder-layout {
  position: relative;
  border: 1px solid #00000000;
  padding: 2px;

  .nomal {
    display: none;
  }
}

.showboder {
  // padding: 5px;
  border: 1px solid #00000040;
  border-style: dashed;
  .btnlist {
    position: absolute;
    left: -1px;
    top: 0px;
    display: flex;
    .updateBtn {
      display: inline;

      // z-index: 99999;
      // width: 150px;
      // height: 150px;

      padding: 8px 12px;
      background: #007ffe;
      // font-style: normal;
      align-items: center;
      cursor: pointer;
      border-radius: 3px;
      color: #fff;
    }
    .deleteBtn {
      display: inline;
      // z-index: 99999;
      // width: 150px;
      // height: 150px;
      margin-left: 10px;
      padding: 8px 12px;
      background: #fd4141;
      border-radius: 3px;
      // font-style: normal;
      align-items: center;
      cursor: pointer;
      color: #fff;
    }
  }
}
.centerslot {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>